import qs from 'qs';

const Dashboard = {
    namespaced: true,

    state: {
        indexList: [],
    },

    getters: {
        indexList (state) {
            return state.indexList;
        },
    },

    mutations: {
        /**
         * Задать показатель
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['indexList'] = items;
        },

        /**
         * Обновить показатель
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['indexList'][index] = item;
        },

        /**
         * Добавить показатель
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['indexList'].push(item);
        },

        /**
         * Удалитьпоказатель
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['indexList'] = state['indexList'].filter(iItem => iItem !== item);
        },
    },


    actions: {
        /**
         * Получение данных о показателях
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getIndexList ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dashboardIndex,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о показателях Dashboard получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN dashboard.js | getIndexList: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных о показателях Dashboard!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных о показателях
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveIndex ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dashboardIndex,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Показатель Dashboard успешно отредактирован!');
                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;

                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый показатель Dashboard успешно создан!');
                    }
                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении показателя Dashboard!');
                    console.log('ERROR IN dashboard.js | saveIndex: ' + err);
                    reject(err);
                })
            })
        },

        /**
         * Удаление показателя Dashboard
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeIndex ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dashboardIndex,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Показатель Dashboard успешно удален!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении показателя Dashboard!'),
                    console.log('ERROR IN dashboard.js | removeIndex: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js